export default "__VITE_ASSET__WcUPj$nO__"